import React, { FC, useEffect, useState } from "react"
import { connect } from "react-redux"
import { KSpan } from "kahuna-base-react-components"

import { fetchUserData } from "../../../actions"
import { selectRelease } from "../../../actions/catalogActions"
import { TakedownActionTabs } from "../../../actions/types"
import { getLanguageJsonFor } from "../../../constants/languages"
import { RootState } from "../../../store"
import { Release, SelectOption, User } from "../../../types"
import Takedown from "../catalog/asset-registry/new-release-action/takedown/Takedown"

type CoManagerWords = ReturnType<typeof getLanguageJsonFor>["co_manager"]

type TakedownCardProps = {
  words: CoManagerWords
  user: User
  selectRelease: (release?: Release, releaseId?: string) => void
  fetchUserData: () => Promise<void>
}

/**
 * The new release page's "Move your album" flow, in the chat. It is the page's own Takedown component
 * rather than a copy of it, so the steps, the calls and the credit checks are the page's: the Spotify
 * artist on the account, then that artist's albums, and each confirmed album is opened at Label Camp.
 */
const TakedownCard: FC<TakedownCardProps> = ({ words, user, selectRelease, fetchUserData }) => {
  const [ready, setReady] = useState(false)
  const [selectedTab, setSelectedTab] = useState<number>(TakedownActionTabs.SPOTIFY_ARTIST)
  const [selectedArtist, setSelectedArtist] = useState<SelectOption>()

  useEffect(() => {
    // The page reads the account again before it starts, the Spotify artist and the credits may have
    // changed since login.
    fetchUserData().finally(() => setReady(true))
  }, [])

  return (
    <div className="co-manager-claim-form co-manager-takedown">
      <KSpan text={words.takedown_title} fontSize={12} lineHeight="16px" fontWeight={500} color="#111" />
      <KSpan text={words.takedown_hint} fontSize={11} lineHeight="15px" color="#888" />
      {ready && (
        <Takedown
          embedded
          user={user}
          setSelectedPage={() => undefined}
          selectedTab={selectedTab}
          setSelectedTab={setSelectedTab}
          selectedArtist={selectedArtist}
          setSelectedArtist={setSelectedArtist}
          selectRelease={selectRelease}
        />
      )}
    </div>
  )
}

const mapStateToProps = (state: RootState) => ({ user: state.auth.user })

export default connect(mapStateToProps, { selectRelease, fetchUserData })(TakedownCard)
